import React, { useState, useMemo } from "react";
import "./Grid.css";
import { useGerenciamento } from "../../Context/GerenciamentoContext";

export default function Grid({ columns = [], data = [], idField = "id" }) {
  const {
    selecionarItem,
    alterarRegistro,
    itemSelecionado,
  } = useGerenciamento();

  const [filterText, setFilterText] = useState("");

  const filteredData = useMemo(() => {
    if (!filterText) return data;

    const value = filterText.toLowerCase();

    return data.filter((row) =>
      columns.some((col) => {
        const cell = row[col.field];
        return (
          cell !== null &&
          cell !== undefined &&
          String(cell).toLowerCase().includes(value)
        );
      })
    );
  }, [filterText, data, columns]);

  const handleClick = (row) => {
    selecionarItem(row);
  };

  const handleDoubleClick = (row) => {
    alterarRegistro(row);
  };

  return (
    <div className="Grid-container">
      <div className="Grid-filter">
        <input
          type="text"
          placeholder="Filtrar resultados..."
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
        />
      </div>

      <table className="Grid-table">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col.header}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {filteredData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="Grid-empty">
                Nenhum registro encontrado.
              </td>
            </tr>
          ) : (
            filteredData.map((row, rowIndex) => {
              const isSelected =
                itemSelecionado &&
                row[idField] === itemSelecionado[idField];

              return (
                <tr
                  key={rowIndex}
                  className={`Grid-row ${isSelected ? "selected" : ""}`}
                  onClick={() => handleClick(row)}
                  onDoubleClick={() => handleDoubleClick(row)}
                >
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {col.formatter
                        ? col.formatter(row[col.field], row)
                        : row[col.field] ?? "-"}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
